import { render } from "./feature-area.vue?vue&type=template&id=c019a886&scoped=true"
import script from "./feature-area.vue?vue&type=script&lang=js"
export * from "./feature-area.vue?vue&type=script&lang=js"

import "./feature-area.vue?vue&type=style&index=0&id=c019a886&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c019a886"]])

export default __exports__